// styles
import './styles/graphic.scss';
import { wrapLongLabels } from './utils/helpers';

export default function (props, container, isMobile) {
  const {
    color,
    data,
    fmtYearAbbrev,
    // fmtYearFull,
    height,
    initialWidth,
    initialHeight,
    margins,
    path,
    width,
    x,
    xAxis,
    y,
    yAxis,
    recessionData,
  } = props;

  // const xTicks = isMobile ? 7 : 7;
  const yTicks = isMobile ? 6 : 6;

  const ticksMobi = ['1/5/85', '1/6/90', '1/7/95', '1/1/00', '1/1/05', '1/2/10', '1/3/15', '1/4/20'];

  const xGrid = xAxis(x)
    // .ticks(xTicks)
    .tickValues(ticksMobi.map(d => new Date(d)))
    .tickFormat(d => (isMobile
      ? `\u0027${fmtYearAbbrev(d)}`
      // : fmtYearFull(d)));
      : `\u0027${fmtYearAbbrev(d)}`));

  // legend
  container.insert('ul', ':first-child')
    .attr('class', 'key')
    .selectAll('li')
    .data(data)
    .enter()
    .append('li')
    .attr('class', 'key-item')
    .html(d => `<span class='key-block' style='background-color:${color(d.id)};'></span> Light crude (May contract)`);

  // svg
  const svg = container.append('svg')
    .attr('width', initialWidth)
    .attr('height', initialHeight);

  const g = svg.append('g')
    .attr('transform', `translate(${[margins.left, margins.top]})`);

  // x axis
  g.append('g')
    .attr('class', 'grid x')
    .attr('transform', `translate(${[0, height]})`)
    .call(xGrid);

 	// y axis
  const yGrid = g.append('g')
    .attr('class', 'grid y')
    .call(yAxis(y).ticks(yTicks));

  // set 0 to black
  const ticks = yGrid.selectAll('.tick');
  ticks.filter(d => d === 0)
    .attr('class', 'tick yzero');

  // hide first tick's text
  // yGrid.select('text').style('display', 'none');

  yGrid.selectAll('text')
    .filter(d => d === -20)
    .text('-$20');

  yGrid.selectAll('text')
    .filter(d => d === -40)
    .text('-$40');

  yGrid.selectAll('text')
    .filter(d => d >= 0)
    .text(d => `$${d}`);

  yGrid.selectAll('line').attr('x2', width);

  // recessions
  const recessions = g.append('g')
    .attr('class', 'recessions');

  recessions.selectAll('.recession')
    .data(recessionData)
    .enter().append('rect')
    .attr('class', 'recession')
    .attr('transform', d => `translate(${[x(d.start), 0]})`)
    .attr('width', d => x(d.end) - x(d.start))
    .attr('height', height)
    .style('fill', 'grey')
    .style('fill-opacity', 0.09);

  recessions.append('text')
    .attr('class', 'label-recession')
    .attr('transform', `translate(${[x(new Date('7/1/90')) + 5, 15]})`)
    .attr('text-anchor', 'start')
    .text('Recession');

  // lines
  const lines = g.append('g')
    .attr('class', 'lines')
    .selectAll('g')
    .data(data)
    .enter()
    .append('g')
    .attr('class', 'line');

  lines.append('path')
    .attr('stroke', d => color(d.id))
    .attr('d', d => path(d.values));

  // labels
  const label = lines.append('g')
    .attr('class', 'data-label');

  const callout = label.append('text')
    .attr('transform', (d) => {
      const d0 = d.values.find((val, index, arr) => index === arr.length - 1);
      const x0 = x(d0.date) + 5;
      const y0 = y(d0.value) + 3;
      return `translate(${[x0, y0]})`;
    });

  callout.append('tspan')
    .attr('x', 0)
    .attr('dy', -20)
    .text((d) => {
      const d0 = d.values.find((val, index, arr) => index === arr.length - 1);
      const { value } = d0;
      // const labelwrap = wrapLongLabels(`$${value.toFixed(1)} April 20 1:15 p.m. ET`);
      return isMobile ? `${`${value.toFixed(2)}`}` : `${`${value.toFixed(2)}`}`;
    })
    .append('tspan')
    .attr('x', 0)
    .attr('dy', 15)
    .text('April 20');
  // .append('tspan')
  // .attr('x', 0)
  // .attr('dy', 15)
  // .text('3:15 p.m. ET');

  // axis label
  label.append('rect')
    .attr('class', 'yaxis-label-rect')
    .attr('transform', `translate(${[x(new Date('2/1/83')), y(140)]})`)
    .attr('width', 45)
    .attr('height', 15);
  label.append('text')
    .attr('class', 'grid y yaxis-label')
    .attr('transform', `translate(${[x(new Date('2/1/83')), y(138)]})`)
    .text('a barrel');
}
